export default "/assets/images/mama-room3.097274ee18612497.png";